/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

document.addEventListener('DOMContentLoaded', () => {
  const rows = document.querySelectorAll('.bctpTableRow');

  if (window.innerWidth > 768) {
    setTimeout(() => {
      rows.forEach(row => {
        const img = row.querySelector('img');
        if (img && img.src.includes('summarumfinance.com')) {
          extractColor(img).then(color => {
            row.style.setProperty('--row-image-color', color);
          });
        }
      });
    }, 100);
  }
});

function extractColor(img) {
  return new Promise((resolve) => {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let viableColors = [];
        
        for (let i = 0; i < imageData.length; i += 4) {
          const r = imageData[i];
          const g = imageData[i + 1];
          const b = imageData[i + 2];
          const brightness = (r + g + b) / 3;
          const alpha = imageData[i + 3];
          
          // Filter out almost-transparent or almost-white colors
          if (brightness > 20 && brightness < 200 && alpha > 120) {
            viableColors.push([r, g, b]);
          }
        }
        
        let selectedColor;
        if (viableColors.length > 0) {
          // Use the first viable color instead of a random one
          selectedColor = viableColors[0];
        } else {
          // Failsafe: use a default color if no viable colors found
          selectedColor = [33, 150, 243]; // A medium blue color
        }
        
        const [r, g, b] = selectedColor;
        resolve(`rgb(${r}, ${g}, ${b})`);
      };
    
      // In case the image is already loaded
      if (img.complete) {
        img.onload();
      }
    } catch (e) {
      console.error(e);
      resolve('rgb(33, 150, 243)'); // Failsafe color in case of error
    }
  });
}

